import Token from '@/di/di.token'

import useService from './useService'

export default function useMediaService() {
  const { service } = useService(Token.MEDIA_SERVICE)
  return { service }
}
